import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Dropdown, MenuItem } from 'react-bootstrap';

import _ from 'lodash';

import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import Shiitake from 'shiitake';
import Icon from 'components/Icon/Icon';
import Rating from 'components/Rating/Rating';
import Thumbnail from 'components/Thumbnails/Thumbnail';
import Pro from 'components/Badges/Pro/Pro';
import Verified from 'components/Badges/Verified/Verified';
import { calculateUserRating } from 'helpers/HelperFunctions';
import styles from './BrowseUserCard.module.scss';

export default class BrowseUserCard extends Component {
  static propTypes = {
    user: PropTypes.object,
    onMessage: PropTypes.func,
    onInvite: PropTypes.func,
    collaborations: PropTypes.array,
  };

  handleMessage = (event) => {
    this.props.onMessage(this.props.user.username);

    event.stopPropagation();
  };

  render() {
    const { user, collaborations } = this.props;
    return (
      <div className={styles.userCardContainer}>
        {/* User Cover Picture */}

        {user ? (
          <Link
            className="no-decoration"
            to={user.links.main_relative}
            title={user.displayname}
          >
            <Thumbnail
              thumbnails={user.covers}
              className={styles.coverPictureContainer}
            />
          </Link>
        ) : (
          <div className={styles.userCoverPlaceholder} />
        )}

        {/* User Profile Picture */}

        {user ? (
          <Link
            className="no-decoration"
            to={user.links.main_relative}
            title={user.displayname}
          >
            <Thumbnail
              thumbnails={user.avatars}
              className={styles.profilePictureContainer}
              circle
            />
          </Link>
        ) : (
          <div className={styles.profilePicturePlaceholder} />
        )}

        {/* {!user && <div className={styles.profilePicturePlaceholder} />} */}

        {/* Displayname & Pro/Verified Badges */}
        {user ? (
          <div className={styles.displayNameContainer}>
            <Link
              className="no-decoration"
              to={user.links.main_relative}
              title={user.displayname}
            >
              {user.displayname}
              <Verified
                user={user}
                style={{
                  position: 'relative',
                  top: '-1px',
                }}
              />
              <Pro
                user={user}
                style={{
                  display: 'inline',
                  fontSize: '10px',
                  position: 'relative',
                  top: '-2px',
                }}
              />
            </Link>
          </div>
        ) : (
          <div className={styles.userBadgesPlaceholder} />
        )}

        <div className={styles.userRatingRow}>
          {/* User Rating */}
          {user && (
            <div className={styles.userRatingContainer}>
              <Link
                className="no-decoration"
                to={user.links.main_relative}
                title={user.displayname}
              >
                <Rating
                  rating={calculateUserRating(user)}
                  style={{ cursor: 'pointer' }}
                />
              </Link>
            </div>
          )}

          {/* User Location */}
          {user && (
            <div className={styles.userLocationContainer}>
              <Link
                className="no-decoration"
                to={user.links.main_relative}
                title={user.displayname}
              >
                <Icon icon="&#xe694;" />{' '}
                {user.location.text !== '' ? user.location.text : 'Unknown'}
              </Link>
            </div>
          )}
        </div>

        {/* User Featured Roles */}
        {user ? (
          <div className={styles.userRoles}>
            <Link
              className="no-decoration"
              to={user.links.main_relative}
              title={user.displayname}
            >
              {user.top_roles.length <= 0
                ? 'No roles'
                : user.top_roles.map((role, i) => (
                    <span key={`uid-${user.id}-role-${i}`}>
                      {`${i > 0 ? ', ' : ''}${role}`}
                    </span>
                  ))}
            </Link>
          </div>
        ) : (
          <div className={styles.userRolesPlaceholder}>
            <div className={styles.userRolesPlaceholderContent} />
          </div>
        )}

        {/* User Bio */}
        {user ? (
          <div className={styles.userBioContainer}>
            <Link
              className="no-decoration"
              to={user.links.main_relative}
              title={user.displayname}
            >
              {user.bio.length > 0 ? (
                <Shiitake renderFullOnServer={false} lines={3}>
                  {user.bio}
                </Shiitake>
              ) : (
                <em>No Bio</em>
              )}
            </Link>
          </div>
        ) : (
          <div className={styles.userBioPlaceholder} />
        )}

        <div className={styles.bottomButtonsContainer}>
          {/* View Portfolio Button */}
          {user && (
            <div className={styles.ctaButton}>
              <LinkContainer to={user.links.main_relative}>
                <Button bsStyle="info" block>
                  View portfolio
                </Button>
              </LinkContainer>
            </div>
          )}

          {/* CTA Buttons */}
          {user && (
            <div className={styles.ctaButton}>
              {collaborations.length > 0 &&
              typeof collaborations[0] === 'object' &&
              collaborations[0].hasOwnProperty('id') ? (
                // Invite Button - to pitch on an existing brief
                <Dropdown
                  style={{ display: 'grid' }}
                  id="hireme"
                  onClick={(event) => event.stopPropagation()}
                >
                  <Dropdown.Toggle bsStyle="success">Invite</Dropdown.Toggle>
                  <Dropdown.Menu>
                    <MenuItem header eventKey="1">
                      Invite to an existing brief
                    </MenuItem>
                    {collaborations.map((brief, key) => (
                      <MenuItem key={brief.id} eventKey={key}>
                        <div
                          className={styles.collaborationDropdownItem}
                          onClick={() => this.props.onInvite(brief, user)}
                        >
                          {brief.text}
                        </div>
                      </MenuItem>
                    ))}
                    <MenuItem divider />
                    <LinkContainer to={'/' + user.username + '/hire'}>
                      <MenuItem eventKey="3">Contact for a project</MenuItem>
                    </LinkContainer>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                // Hire Button
                <span>
                  {user && (
                    <LinkContainer to={'/' + user.username + '/hire'}>
                      <Button bsStyle="success" block>
                        Contact
                      </Button>
                    </LinkContainer>
                  )}
                </span>
              )}
            </div>
          )}
          {!user &&
            _.times(2, (i) => (
              <div
                key={`cta-plchldr-${i}`}
                className={styles.disabledCTAContainer}
              >
                <div className={styles.disabledCTAButton} />
              </div>
            ))}
        </div>
      </div>
    );
  }
}
